import React from 'react';
import { addModule, addReducers } from '../connector';
import Home from './Home';
// import {Icon} from 'common/components'
export const ROOT = '/';
export const MODULE = 'HOMEPAGE';


// addReducers({ admins: reducers });
addModule(
    { path: `${ROOT}`, component: Home, icon: 'laptop-code', title: "Home Page", exact: 1, hideNav: 0 },
)
